import React, { useEffect, useState } from "react";
import { InfoHeader } from "../../../customComponent/InfoHeader";
import { Box, FormLabel, Grid, Typography } from "@mui/material";
import { MainContainer } from "../../../content/content.element";
import InputField, {
  SelectInputField,
} from "../../../customComponent/InputField";
import { SubmitButton, SwitchButton } from "../../../customComponent/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import TopicUploadComponent from "../../../customComponent/TopicUploadComponent";
import { useDispatch, useSelector } from "react-redux";
import { ieltsCategoryFindAction } from "../../../../actions/IeltsActions/learningManadmentAction";
import {
  ieltsCourseManagmentQuestionBankCreateAction,
  ieltsCourseManagmentQuestionBankFindbyIdAction,
  ieltsCourseManagmentQuestionBankPdfDeleteAction,
  ieltsCourseManagmentQuestionBankUpdateAction,
} from "../../../../actions/IeltsActions/courseManagmentAction";
import { successTrueMsgAction } from "../../../../actions/globalAction";
import Swal from "sweetalert2";

function QuestionBankEditNewForm({ toggle }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});
  const [isDeleted, setIsDeleted] = useState(false);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [uploadedQuestionBank, setUploadedQuestionBank] = useState("");
  const [err, setErr] = useState({
    title: "",
    category: "",
    uploadedExamTips: "",
    all: "",
  });

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (event) => {
    setUploadedQuestionBank(event.target.files[0]);
    setIsDeleted(false);
  };

  const handleDelete = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  // Category List

  let { ieltsCategoryFindSuccess, ieltsCategoryFinderror } = useSelector(
    (state) => {
      return state.ieltsCategoryList;
    }
  );

  let {
    ieltsCourseManagmentQuestionBankFindByIdSuccess,
    ieltsCourseManagmentQuestionBankFindByIderror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankFindById;
  });

  let {
    ieltsCourseManagmentQuestionBankPdfDeleteSuccess,
    ieltsCourseManagmentQuestionBankPdfDeleteerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankPdfDelete;
  });

  useEffect(() => {
    dispatch(ieltsCategoryFindAction("topicsAdd"));
  }, [dispatch]);

  useEffect(() => {
    if (ieltsCategoryFindSuccess) {
      setCategoryList(ieltsCategoryFindSuccess.data);
    }
  }, [ieltsCategoryFindSuccess]);

  // useEffect to fech already added question bank

  useEffect(() => {
    dispatch(ieltsCourseManagmentQuestionBankFindbyIdAction(id));
  }, [dispatch, ieltsCourseManagmentQuestionBankPdfDeleteSuccess]);

  useEffect(() => {
    if (ieltsCourseManagmentQuestionBankFindByIdSuccess) {
      setTitle(ieltsCourseManagmentQuestionBankFindByIdSuccess?.data?.title);
      setCategory(
        ieltsCourseManagmentQuestionBankFindByIdSuccess?.data?.category
      );
      setUploadedQuestionBank(
        ieltsCourseManagmentQuestionBankFindByIdSuccess?.data?.questionBankUrl
      );
    }
  }, [ieltsCourseManagmentQuestionBankFindByIdSuccess]);



  // Success message

  let { successAlertMsgSuccess } = useSelector((state) => {
    return state.successTrueMsg;
  });

  let {
    ieltsCourseManagmentQuestionBankUpdateSuccess,
    ieltsCourseManagmentQuestionBankUpdateerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankUpdate;
  });

  useEffect(() => {
    if (
      successAlertMsgSuccess &&
      ieltsCourseManagmentQuestionBankUpdateSuccess?.status == true
    ) {
      Swal.fire("Updated", "QuestionBank updated successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
    if (
      successAlertMsgSuccess &&
      ieltsCourseManagmentQuestionBankUpdateSuccess?.status == false
    ) {
      Swal.fire("Error", "QuestionBank not updated.", "warning");
      dispatch(successTrueMsgAction(false));
    }
  }, [ieltsCourseManagmentQuestionBankUpdateSuccess, successAlertMsgSuccess]);

  // Handle DeleteFunction

  
  const handleDeleteFunction = () => {
    setIsDeleted(true);
  };
 

  // Handle function for adding QuestionBank

  const handleAddNewButton = () => {
    let isValid = true;
    if (!title && !category && !uploadedQuestionBank) {
      setErr({ all: "Add Question bank details" });
      isValid = false;
    }
    if (!category) {
      setErr({ category: "Enter category name" });
      isValid = false;
    }
    if (!title) {
      setErr({ title: "Enter title" });
      isValid = false;
    }
    if (!uploadedQuestionBank) {
      setErr({ uploadedQuestionBank: "Upload question bank pdf" });
      isValid = false;
    }
    if (!isValid) {
      return;
    }
     if (isDeleted) {
       dispatch(ieltsCourseManagmentQuestionBankPdfDeleteAction(id));
     } 
    const formData = new FormData();
    formData.append("title", title);
    formData.append("category", category);
    formData.append("uploadQuestionBank", uploadedQuestionBank);
    formData.append("id", id);
    dispatch(ieltsCourseManagmentQuestionBankUpdateAction(formData));
    dispatch(successTrueMsgAction(true));
  };

  return (
    <MainContainer active={toggle}>
      <InfoHeader headTitle="Question Bank" url="/IELTS" />

      <div style={{ marginTop: "30px" }}>
        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            "& .input-group": {
              mb: "44px",
              mt: "0",
            },
          }}
        >
          <InputField
            label="Title"
            handleChange={(e) => {
              setTitle(e.target.value);
            }}
            value={title}
            widthSize="546px"
            required
            paramses
            InputType="text"
            dispcriptionHeight
          />
        </Grid>

        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            "& .MuiFormControl-root": {
              maxWidth: "558px",
            },
          }}
        >
          <SelectInputField
            mapValue={categoryList}
            label="Select Category"
            handleSelectChange={(e) => setCategory(e.target.value)}
            widthSize="558px"
            value={category}
            mapMethod="ieltsCategory"
          />
        </Grid>

        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            mt: "32px",
          }}
        >
          {!uploadedQuestionBank || isDeleted ? (
            <Box>
              <Typography
                sx={{
                  color: "#05050F",
                  fontSize: "16px",
                  lineHeight: "20px",
                  mb: "23px",
                }}
              >
                Upload File
              </Typography>
              <FormLabel
                sx={{
                  boxSizing: "border-box",
                  width: "100%",
                  maxWidth: "558px",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                  display: "flex",
                  alignItems: "center",
                  pl: "14px",
                  pr: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: formData.logoFile ? "#05050F" : "#ACB1C6",
                    textAlign: "left",
                    width: "100%",
                  }}
                >
                  Choose File
                </Typography>
                <input
                  type="file"
                  hidden
                  name="logoFile"
                  multiple
                  onChange={(e) => handleFileChange(e)}
                  accept=".pdf"
                />
                <Box
                  sx={{
                    cursor: "pointer",
                    padding: "4px 18px",
                    background: "#EBF2FD",
                    color: "#1E88E5",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Browse
                </Box>
              </FormLabel>
            </Box>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4,234px)",
                padding: "30px 20px",
                background: "#F5F5F5",
                gap: "20px",
              }}
            >
              <Box>
                <TopicUploadComponent
                  type="pdf"
                  title={title}
                  handleClick={handleDeleteFunction}
                />
              </Box>
            </Box>
          )}
        </Grid>

        <Box
          sx={{
            mt: "44px",
          }}
        >
          <SubmitButton
            title="Add New"
            submit=""
            widthSize="123px"
            heightSize="38px"
            type="click"
            handleSubmit={handleAddNewButton}
          />
        </Box>
      </div>
    </MainContainer>
  );
}

export default QuestionBankEditNewForm;
